import { useSelector } from 'react-redux';
import useGetOfficialSiteURL from 'hooks/useGetOfficialSiteURL';

import { getLiveTopicInfo } from 'reduxModules/live/selector';
import { getContentMainCheckoutCollection } from 'reduxModules/checkoutCollection/selector';
import { SINGLE_PURCHASE_TEMPLATE } from 'constants/routingPath';

import { REGULAR_CLASS } from 'constants/contentTypes';

export default function useLiveMainCheckoutCollectionUrl() {
  const { id: liveTopicId } = useSelector(getLiveTopicInfo);
  const getOfficialSiteURL = useGetOfficialSiteURL();

  const { id } = useSelector(
    getContentMainCheckoutCollection(REGULAR_CLASS, liveTopicId),
  );

  if (!id) return undefined;

  const singleTopicCheckoutCollectionUrl = getOfficialSiteURL(
    `${SINGLE_PURCHASE_TEMPLATE}#from=${REGULAR_CLASS}:${liveTopicId}`,
    {
      id,
    },
  );

  return singleTopicCheckoutCollectionUrl;
}
